// import en from './en';
// import cn from './cn';

// export default {
//     en: en,
//     cn: cn,

// }

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const messages = {
  enUS:{
    message:{
      pleaseEnterRoleName:'Enter Rolename',
      // text1:"Select subtype",
      // text2:"Outsource",
      // text3:"Trainee",
      // text4:"Report to superior SAPcode",
    },
    ...enLocale
  },
  zhCN:{
    message:{
      pleaseEnterRoleName:'请输入角色名称',
      // text1:"选择子类型",
      // text2:"外包",
      // text3:"实习生",
      // text4:"汇报上级SAPcode",
    },
    ...zhLocale
  }
}
export default messages



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js